import { apiSaveStep, API_STEPS } from "../api/apiSaveStep";
import { PERSONAL_DATA_FORM_FIELDS_NAMES } from "./personalDataForm";
import { SUPPLY_ADDRESS_FORM_FIELD_NAMES } from "./supplyAddressForm";
import { ERROR_TEXTS, VALIDATORS_TYPE, PAYMENT_METHODS, SHIPMENT_METHODS } from "../utils/constants";
import { fieldValidator } from "../utils/fieldValidator";
import { apiGenerateOtp } from "../api/apiGenerateOtp";
import toponimi from "../static/resources/toponimiGrouped.json";
import { getFullPlaceNameFromCode } from "../utils/getToponimoFromAddress";

const FIELD_REQUIRED_MESSAGE = 'Campo obbligatorio';
export const PAYMENT_RECAP_FIELD_NAMES = {
    /**Se l'utente vuole ricevere la bolletta via email (Sempre a true) */
    hasDigitalBill: 'bollettaDigitale',
    /**Se l'utente addebita sul conto corrente */
    // hasChargeBankAccount: 'addebitoContoCorrente',

    paymentMethod: 'metodoPagamento',
    /**Se l'utente addebito su bollettino postale */
    hasChargePostal: 'bollettinoPostale',

    /**Field no longer used */
    identityNumber: 'numeroDocumento',
    /**Field no longer used */
    identityNumberError: 'numeroDocumentoErrore',
    releaseDate: 'dataRilascio',
    /**Field no longer used */
    releaseDateError: 'dataRilascioErrore',
    /**Field no longer used */
    releasedBy: 'rilasciatoDa',
    /**Field no longer used */
    releasedByError: 'rilasciatoDaErrore',

    /**Se la bolletta viene mandata allo stesso indirizzo email specificato nella pagina dati personali */
    isDigitalBillEmailSame: 'emailBollettaUgualeDatiPersonali',
    /**Indirizzo email sul quale ricevere l'email */
    emailDigitalBill: 'emailRecapitoBolletta',
    emailDigitalBillConfirmation: 'emailDigitalBillConfirmation',
    emailDigitalBillError: 'emailRecapitoBollettaErrore',
    emailDigitalBillConfirmationError: 'emailDigitalBillConfirmationError',

    /**Iban conto corrente */
    iban: 'iban',
    ibanError: 'ibanError',

    /**Se il propietario del conto corrente è uguale all'utente che si sta registrando */
    isOwnerBankAccountSame: 'titolareContoUgualeFornitura',

    /**Nome del proprietario del conto corrente */
    ownerBankAccountName: 'titolareContoNome',
    /**Cogmome del proprietario del conto corrente */
    ownerBankAccountSurname: 'titolareContoCognome',
    /**Codice fiscale del proprietario del conto corrente */
    ownerBankAccountFiscalCode: 'titolareContoCodiceFiscale',
    /**Se il possessore del conto corrente ha accettato la privacy */
    hasOwnerBankAccountPrivacy: 'hasOwnerBankAccountPrivacy',

    ownerBankAccountNameError: 'titolareContoNomeError',
    ownerBankAccountSurnameError: 'titolareContoCognomeError',
    ownerBankAccountFiscalCodeError: 'titolareContoCodiceFiscaleError',

    /**Se l'utente desidera ricevere il bollettino postale allo stesso indirizzo indicato nella pagina supplier */
    hasPostalSameAddress: 'bollettinoViaIndirizzo',

    billAddressPlaceNameOptions: 'billAddressPlaceNameOptions',
    billAddressPlaceNameText: 'bollettinoPostaleToponimoIndirizzoText',
    billAddressPlaceNameCode: 'bollettinoPostaleToponimoIndirizzo',
    /**Indirizzo al quale ricevere il bollettino postale */
    billAddress: 'bollettinoPostaleIndirizzo',
    billAddressSuffix: 'bollettinoPostaleSuffissoIndirizzo',
    /**Numero civico al quale ricevere il bollettino postale */
    billAddressNumber: 'bollettinoPostaleNumeroCivico',
    /**Comune al quale ricevere il bollettino postale */
    billAddressMunicipality: 'bollettinoPostaleComune',
    /**Cap al quale ricevere il bollettino postale */
    billAddressCap: 'bollettinoPostaleCap',
    /**Provincia al quale ricevere il bollettino postale */
    billAddressProvince: 'bollettinoPostaleProvincia',

    billAddressPlaceNameTextError: 'billAddressPlaceNameTextError',
    billAddressPlaceNameCodeError: 'billAddressPlaceNameCodeError',
    billAddressError: 'bollettinoPostaleIndirizzoError',
    billAddressNumberError: 'bollettinoPostaleNumeroCivicoError',
    billAddressMunicipalityError: 'bollettinoPostaleComuneError',
    billAddressCapError: 'bollettinoPostaleCapError',
    billAddressProvinceError: 'bollettinoPostaleProvinciaError',

    timeSpent: 'tempoImpiegato',
    timeStart: 'timeStart',
    isSubmittingForm: 'isSubmittingForm',
    errorFormSubmission: 'errorFormSubmission',
    successText: 'successText'
}

const REQUIRED_FIELDS_BANK = [
    PAYMENT_RECAP_FIELD_NAMES.iban,
    PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName,
    PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname,
    PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode,
];

const REQUIRED_FIELDS_POSTAL = [
    PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText,
    PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode,
    PAYMENT_RECAP_FIELD_NAMES.billAddress,
    PAYMENT_RECAP_FIELD_NAMES.billAddressNumber,
    PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality,
    PAYMENT_RECAP_FIELD_NAMES.billAddressCap,
    PAYMENT_RECAP_FIELD_NAMES.billAddressProvince,
];



const MAP_FIELD_ERROR = {
    [PAYMENT_RECAP_FIELD_NAMES.identityNumber]: PAYMENT_RECAP_FIELD_NAMES.identityNumberError,
    [PAYMENT_RECAP_FIELD_NAMES.releaseDate]: PAYMENT_RECAP_FIELD_NAMES.releaseDateError,
    [PAYMENT_RECAP_FIELD_NAMES.releasedBy]: PAYMENT_RECAP_FIELD_NAMES.releasedByError,


    [PAYMENT_RECAP_FIELD_NAMES.iban]: PAYMENT_RECAP_FIELD_NAMES.ibanError,

    [PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName]: PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountNameError,
    [PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname]: PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurnameError,
    [PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode]: PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCodeError,

    [PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText]: PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameTextError,
    [PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode]: PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCodeError,
    [PAYMENT_RECAP_FIELD_NAMES.billAddress]: PAYMENT_RECAP_FIELD_NAMES.billAddressError,
    [PAYMENT_RECAP_FIELD_NAMES.billAddressNumber]: PAYMENT_RECAP_FIELD_NAMES.billAddressNumberError,
    [PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality]: PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipalityError,
    [PAYMENT_RECAP_FIELD_NAMES.billAddressCap]: PAYMENT_RECAP_FIELD_NAMES.billAddressCapError,
    [PAYMENT_RECAP_FIELD_NAMES.billAddressProvince]: PAYMENT_RECAP_FIELD_NAMES.billAddressProvinceError,
}

const defaultErrorState = {
    [PAYMENT_RECAP_FIELD_NAMES.identityNumberError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.releaseDateError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.releasedByError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission]: '',

    [PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillConfirmationError]: '',

    [PAYMENT_RECAP_FIELD_NAMES.ibanError]: '',

    [PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountNameError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurnameError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCodeError]: '',

    [PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameTextError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCodeError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressNumberError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipalityError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressCapError]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressProvinceError]: '',

    [PAYMENT_RECAP_FIELD_NAMES.successText]: ''
}

const defaultState = {
    [PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill]: 'bollettaDigitale',
    [PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame]: true,
    [PAYMENT_RECAP_FIELD_NAMES.paymentMethod]: PAYMENT_METHODS.bankAccount,
    [PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]: true,

    [PAYMENT_RECAP_FIELD_NAMES.identityNumber]: '',
    [PAYMENT_RECAP_FIELD_NAMES.releaseDate]: '',
    [PAYMENT_RECAP_FIELD_NAMES.releasedBy]: '',

    [PAYMENT_RECAP_FIELD_NAMES.emailDigitalBill]: '',
    [PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillConfirmation]: '',

    [PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame]: true,
    [PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName]: '',
    [PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname]: '',
    [PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode]: '',
    [PAYMENT_RECAP_FIELD_NAMES.hasOwnerBankAccountPrivacy]: true,
    [PAYMENT_RECAP_FIELD_NAMES.iban]: '',

    [PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameOptions]: [],
    [PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddress]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressSuffix]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressNumber]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressCap]: '',
    [PAYMENT_RECAP_FIELD_NAMES.billAddressProvince]: '',

    [PAYMENT_RECAP_FIELD_NAMES.timeSpent]: 0,
    [PAYMENT_RECAP_FIELD_NAMES.timeStart]: null,
    [PAYMENT_RECAP_FIELD_NAMES.isSubmittingForm]: false,
    ...defaultErrorState,
}

const PAYMENT_RECAP_CHANGE_FIELD = 'PAYMENT_RECAP_CHANGE_FIELD';
export function paymentRecapChangeField(name, value) {
    return { type: PAYMENT_RECAP_CHANGE_FIELD, name, value }
}

const PAYMENT_RECAP_RESET_ERROR = 'PAYMENT_RECAP_RESET_ERROR';
export function paymentRecapResetError(name) {
    return { type: PAYMENT_RECAP_RESET_ERROR, name }
}

const PAYMENT_RECAP_SET_ERROR_TEXT = 'PAYMENT_RECAP_SET_ERROR_TEXT';
function paymentRecapSetErrorText(name, value) {
    return {
        type: PAYMENT_RECAP_SET_ERROR_TEXT,
        name,
        value
    }
}

let paymentAddressPlaceNameTimeout = null;
export function paymentRecapPlaceNameFilter(value) {
    return dispatch => {
        clearTimeout(paymentAddressPlaceNameTimeout);
        paymentAddressPlaceNameTimeout = setTimeout(() => {
            if (!value || value.length === 0) {
                return dispatch(paymentRecapChangeField(
                PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameOptions, toponimi['V']));
            }
    
            value = value.toUpperCase();
            const firstChar = value.charAt(0);
            const toponimiToSearchFrom = toponimi[firstChar];
            if (!toponimiToSearchFrom) {
                return dispatch(paymentRecapChangeField(
                PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameOptions, []));
            }
    
            dispatch(paymentRecapChangeField(
                PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameOptions,
                toponimi[firstChar].filter(s => s.TOP_DESCRIZIONE_BREVE.indexOf(value) !== -1)
            ));
        }, 500);
    }
}

export const paymentRecapValidateAndProceed = (finished = true) => {
    return async (dispatch, getState) => {
        const { paymentRecapReducer: form, personalDataForm, supplyAddressForm, globalFormFieldsReducer } = getState();
        const otp = globalFormFieldsReducer.otp;
        let error = false;

        const formToSend = { ...form };

        const timeSpent = form[PAYMENT_RECAP_FIELD_NAMES.timeSpent]
            + parseInt(Date.now() / 1000, 10) - form[PAYMENT_RECAP_FIELD_NAMES.timeStart];

        form[PAYMENT_RECAP_FIELD_NAMES.timeSpent] = timeSpent;
        dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.timeSpent, timeSpent));
        dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.timeStart, parseInt(Date.now() / 1000, 10)));


        // Reset the error fields
        dispatch(paymentRecapResetError());

        // Se il possessore del conto bancario è lo stesso che sta eseguendo la registrazione
        if (form[PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame]) {
            formToSend[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName] = personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.name];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname] = personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.surname];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode] = personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode];
        }

        // Se l'indirizzo della fattura via posta è lo stesso di quello indicato nello step della fornitura
        if (form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]) {
            formToSend[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText] = supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode] = supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.billAddress] = supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.address];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.billAddressNumber] = supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.billAddressSuffix] = supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressSuffix];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality] = supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.billAddressCap] = supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.billAddressProvince] = supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.province];
        }
        // se l'utente desidera inviare la bolletta cartacea
        if (form[PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill] == 'bollettaCartacea') {
            formToSend[PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill] = false
            //alert(formToSend[PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill])
        }
        // Se l'utente desidera specificare un altro indirizzo email lo aggiungiamo ai campi richiesti
        if (form[PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame]) {
            formToSend[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBill] = personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.email];
            formToSend[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillConfirmation] = personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.email];
        }

        if (!finished) {
            dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.isSubmittingForm, true));
            try {
                await apiSaveStep(API_STEPS.third, {
                    ...formToSend,
                    otp,
                    finished: false
                });
                await apiGenerateOtp(otp);
                return dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.successText, ERROR_TEXTS.saveSuccess));
            } catch (error) {
                dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission, 'Errore nel salvare i dati'));
                throw "Error saving data";
            } finally {
                dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.isSubmittingForm, false));
            }
        }

        let requiredFields = [];
        if (form[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.postal) {
            requiredFields = REQUIRED_FIELDS_POSTAL;
        } else if (form[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.bankAccount) {
            requiredFields = REQUIRED_FIELDS_BANK;
        }
        requiredFields = [...requiredFields,];

        // Controlla i campi richiesti
        for (let field of requiredFields) {
            if (!formToSend[field] || formToSend[field].length < 0) {
                console.log(field, MAP_FIELD_ERROR[field])
                dispatch(paymentRecapSetErrorText(MAP_FIELD_ERROR[field], FIELD_REQUIRED_MESSAGE));
                error = true;
            }
        }
        if (error) {
            dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission, 'È necessario compilare tutti i campi.'));
            throw "Missing fields";
        }

        // Check if the email is in the correct format
        if (!fieldValidator(formToSend[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBill], VALIDATORS_TYPE.email)) {
            dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillError, ERROR_TEXTS.validationError));
            dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.globalValidationError));
            throw "Invalid email";
        }

        // Check if the confirmation email is equal
        if (formToSend[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBill] !== formToSend[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillConfirmation]) {
            dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillConfirmationError, ERROR_TEXTS.emailsNotEqual));
            dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.emailsNotEqual));
            throw "emails not equal";
        }

        // Check if the privacy field is accepted
        if (
            formToSend[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.bankAccount
            && !formToSend[PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame]
            && !formToSend[PAYMENT_RECAP_FIELD_NAMES.hasOwnerBankAccountPrivacy]
        ) {
            dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.privacyNotAccepted));
            throw "Privacy not accepted";
        }

        // Validate iban
        if (formToSend[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.bankAccount) {
            if (!fieldValidator(formToSend[PAYMENT_RECAP_FIELD_NAMES.iban], VALIDATORS_TYPE.iban)) {
                dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.ibanError, ERROR_TEXTS.invalidIban));
                dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.invalidIban));
                throw 'invalid iban';
            }
        }

        // Validate fiscal code of bank account owner
        if (formToSend[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.bankAccount) {
            try {
                fieldValidator(
                    formToSend[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode],
                    VALIDATORS_TYPE.fiscalCode,
                );
            } catch (error) {
                if (error === 'invalid') {
                    dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCodeError, ERROR_TEXTS.invalidFiscalCode));
                    dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.invalidFiscalCode));
                    throw 'invalid fiscal code';
                } else {
                    dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCodeError, ERROR_TEXTS.ageFiscalCode));
                    dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.ageFiscalCode));
                    throw 'invalid fiscal age';
                }
            }
        }

        // Set is submitting form
        dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.isSubmittingForm, true));

        try {
            await apiSaveStep(API_STEPS.third, {
                ...formToSend,
                otp,
                finished: true
            });
        } catch (error) {
            dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission, 'Errore nel salvare i dati'));
            throw "Error saving data";
        } finally {
            dispatch(paymentRecapChangeField(PAYMENT_RECAP_FIELD_NAMES.isSubmittingForm, false));
        }
    }
}

const PAYMENT_RECAP_SET_FROM_MODEL = 'PAYMENT_RECAP_SET_FROM_MODEL';
export const paymentRecapSetFromModel = state => {
    // Get the place name for the address
    if (state.thirdStep[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode]) {
        const placeName = getFullPlaceNameFromCode(state.thirdStep[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode]);
        if (placeName) state.thirdStep[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText] = placeName.TOP_DESCRIZIONE_BREVE;
    }
    if (!state.thirdStep[PAYMENT_RECAP_FIELD_NAMES.paymentMethod]) {
        state.thirdStep[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] = PAYMENT_METHODS.bankAccount;
    }
    return { type: PAYMENT_RECAP_SET_FROM_MODEL, state: state.thirdStep }
}

export function paymentRecapReducer(state = defaultState, action) {
    switch (action.type) {
        case PAYMENT_RECAP_CHANGE_FIELD: {
            if (MAP_FIELD_ERROR[action.name]) {
                return { ...state, [action.name]: action.value, [MAP_FIELD_ERROR[action.name]]: '' }
            } else {
                return { ...state, [action.name]: action.value }
            }
        }
        case PAYMENT_RECAP_SET_ERROR_TEXT: {
            return { ...state, [action.name]: action.value }
        }
        case PAYMENT_RECAP_RESET_ERROR: {
            if (action.name) {
                return { ...state, [action.name]: '' }
            } else {
                return { ...state, ...defaultErrorState }
            }
        }
        case PAYMENT_RECAP_SET_FROM_MODEL: {
            return { ...state, ...action.state }
        }
        default: {
            return state;
        }
    }
}